import React from 'react';
import styles from './news-feed-item.module.scss';
import { isToday } from 'shared/utils/date.utils';
import { useDateFormatter } from 'shared/hooks/dates.hooks';
import { Link } from 'react-router-dom';
import {
  COMMUNICATION_CENTER_NAVIGATION_SOURCE,
  COMMUNICATIONS_TYPES,
  EVENTS,
  QUALITY_METRICS_NAVIGATION_SOURCE,
  ROUTES,
} from 'shared/constants';
import { useSelector } from 'react-redux';
import analyticsService from 'src/helpers/analytics.service';
import { QualityMetricIcon } from 'src/images';
import { getLang } from 'shared/store/selectors/lang.selector';

export function QualityMetricNotification({
  id,
  title,
  createdAt,
  source = COMMUNICATION_CENTER_NAVIGATION_SOURCE.DASHBOARD_WIDGET,
  type = COMMUNICATIONS_TYPES.QUALITY,
}) {
  const { formatShortDateTime, formatShortTime } = useDateFormatter();
  const organization = useSelector(state => state.organization);
  const lang = useSelector(getLang('QUALITY_METRIC'));
  const orgName = `${organization?.name} ` || '';
  const sender = `${orgName}${lang.QUALITY_DIRECTOR}, `;

  const onNavigateToNotification = () => {
    analyticsService.track(EVENTS.COMMUNICATION_CENTER.NOTIFICATION_CLICKED, {
      notificationId: id,
      notificationType: type,
      source,
    });
  };

  return (
    <Link
      to={ROUTES.QUALITY_METRIC}
      onClick={onNavigateToNotification}
      state={{ notificationId: id, source: QUALITY_METRICS_NAVIGATION_SOURCE.NOTIFICATION_WIDGET }}
      className={styles.link}
    >
      <div className={styles.root}>
        <div className={styles.rightSide}>
          <img className={styles.icon} src={QualityMetricIcon} alt="Quality metric icon" />
          <div className={styles.body}>
            <p className={styles.title}>{title}</p>
            <label className={styles.date}>
              {sender}
              {isToday(createdAt) ? formatShortTime(createdAt) : formatShortDateTime(createdAt)}
            </label>
          </div>
        </div>
      </div>
    </Link>
  );
}
